import { BaseApi } from './base.api.js';

export class EventObservabilityApi extends BaseApi {
    constructor(client) {
        super(client, '/event-observability');
    }

    async getSummary() {
        const response = await this.client.get(`${this.basePath}/summary`);
        return response.data;
    }

    async getRecentActivity(params = {}) {
        const response = await this.client.get(`${this.basePath}/activity`, { params });
        return response.data;
    }

    async getTopEvents(params = {}) {
        const response = await this.client.get(`${this.basePath}/top-events`, { params });
        return response.data;
    }

    async getWorkerHealth() {
        const response = await this.client.get(`${this.basePath}/workers/health`);
        return response.data;
    }
}
